const loader = (method) => {
	const el = document.getElementById('js-loader-ajax');
	const elClass = 'active';
	const fn = {
		add: () => {
			el.classList.add(elClass);
		},
		remove: () => {
			el.classList.remove(elClass);
		},
		toggle: () => {
			el.classList.toggle(elClass);
		},
	};

	fn[method]();
};

export default loader;
